import { useSelector } from "react-redux";
// import BrokerDashTable from "./BrokerDashTable";
import PastPaymentsTable from "../../components/AllTables/PastPaymentsTable";
import LoanChargesTables from "../../components/AllTables/LoanChargesTables.jsx";
import PortfolioAtAGlanceTable from "../../components/AllTables/PortfolioAtAGlanceTable.jsx";
import UpcomingPaymentsTable from "../../components/AllTables/UpcomingPaymentsTable.jsx";
import AdditionalInterestSkimTables from "../../components/AllTables/AdditionalInterestSkimTables.jsx";
import PastLoanPortfolioTable from "../../components/AllTables/PastLoanPortfolioTable.jsx";
import AttachmentsTab from "../LoanDetails/AttachmentsTab";
import NewMsaPopup from "../../components/MsaAgreement/NewMsaPopup";
import { fetchPortfolioAtGlanceBroker, fetchPortfolioAtGlanceBrokerNew } from "../../store/reducers/dashboardSlice/api.js";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer.jsx";
import ActiveLoanSnapShotTable from "../../components/AllTables/ActiveLoanSnapShotTable";
import { roleType } from "../../Utils/constant.js";

const TableSection = () => {
  const selectedRole = useSelector((state) => state.account.selectedRole);

  const shouldHideLoanChargesTables = selectedRole.label.includes("ROC");
  const componentConfig = [
    {
      component: (
        <PortfolioAtAGlanceTable
          className="col-sm-12"
          // fetchKey={fetchPortfolioAtGlanceBroker}
          fetchKey={fetchPortfolioAtGlanceBrokerNew}
        />
      ),
      role: [roleType.broker, roleType.brokerAdmin],
      className: "col-sm-12",
    },
    {
      component: <PortfolioAtAGlanceTable className="col-sm-12" />,
      role: [roleType.lender, roleType.lenderAdmin],
      className: "col-sm-12",
    },
    {
      component: <UpcomingPaymentsTable className="col-sm-12" />,
      role: [
        roleType.broker,
        roleType.lender,
        roleType.lenderAdmin,
        roleType.brokerAdmin,
      ],
      className: `col-sm-12 ${
        selectedRole?.value === roleType.broker ? "col-lg-12" : "col-lg-6"
      }`,
    },
    {
      component: <ActiveLoanSnapShotTable className="col-sm-12" />,
      role: [roleType.broker, roleType.brokerAdmin],
      className: "col-sm-12 col-lg-12",
    },
    {
      component: <PastLoanPortfolioTable className={"col-sm-12"} />,
      role: [roleType.broker, roleType.brokerAdmin],
      className: "col-sm-12",
    },
    {
      component: <AdditionalInterestSkimTables className={"col-sm-12"} />,
      role: [roleType.broker, roleType.brokerAdmin],
      className: "col-sm-12",
    },
    {
      component: <PastPaymentsTable className={"col-sm-12"} />,
      role: [roleType.broker, roleType.brokerAdmin],
      className: "col-sm-12",
    },
    {
      component: <PastLoanPortfolioTable className="col-sm-12" />,
      role: [roleType.lender, roleType.lenderAdmin],
      className: "col-sm-12 col-lg-6",
    },
    {
      component: <PastPaymentsTable className="col-sm-12" />,
      role: [roleType.lender, roleType.lenderAdmin],
      className: "col-sm-12",
    },
    {
      component: <AdditionalInterestSkimTables className="col-sm-12" />,
      role: [roleType.lender, roleType.lenderAdmin],
    },
    {
      component: (
        <LoanChargesTables
          className={`col-sm-12 loan-charges ${
            shouldHideLoanChargesTables ? "d-none" : ""
          }`}
        />
      ),
      role: [roleType.lender, roleType.lenderAdmin],
    },
    {
      component: <AttachmentsTab className="col-sm-12" />,
      role: [
        roleType.lender,
        roleType.lenderAdmin,
        roleType.broker,
        roleType.brokerAdmin,
      ],
      className: "col-12 rounded p-4",
    },
  ];

  return (
    <article className="container-fluid">
      <NewMsaPopup />
      <section className="row">
        <DynamicComponentRenderer componentConfig={componentConfig} />
      </section>
    </article>
  );
};

export default TableSection;
